<template>
  <div class="mainPage">
    <p id="headPage">Jenis Product</p>
    
    <div id="titleRow">
      <b-button id="addModal" @click.prevent="showAdd()">Tambah Data</b-button>
    </div>
    <!-- <div class="pagination mt-2">
        <button type="button" class="mr-1" id="pageButton" v-if="currentPage > 1"  @click.prevent="minPage()"> &lt; </button>
        <button class="mr-1" id="pageButton" v-if="currentPage <= 1"  > &lt; </button>
        <p class="mr-1"> {{this.currentPage}} </p>
        <p class="mr-1">/</p> 
        <p class="mr-1">{{this.totalPage}} </p> 
        <button type="button" id="pageButton" v-if="this.currentPage < this.totalPage" @click.prevent="addPage()"> > </button>
        <button id="pageButton" v-if="this.currentPage >= this.totalPage" > > </button>
      </div> -->
    <div class="tableRow">
      <div class="inRow">
        <lord-icon
          v-if="this.isLoading"
          src="https://cdn.lordicon.com/dpinvufc.json"
          trigger="loop"
          style="width:300px;height:300px">
        </lord-icon>
      </div>
      <table v-if="!isLoading" class="table-bordered table-hover" id="tableData">
        <thead>
          <tr>
            <th>Nama Product</th>
            <th>Type Product</th>
            <!-- <th colspan="2">Aksi</th> -->
            <th>Aksi</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="e in this.dataTable" :key="e.id">
            <td> {{e.produckName}} </td>
            <td> {{e.type}} </td>
            <td id="action" class="text-center" >
                <button @click.prevent="showEdit(e)" title="Edit" >
                  <lord-icon
                    src="https://cdn.lordicon.com/nxaaasqe.json"
                    trigger="hover">
                  </lord-icon>
                </button>
                <button @click.prevent="confirmDelete(e.id)" title="Hapus">
                    <lord-icon
                        src="https://cdn.lordicon.com/gsqxdxog.json"
                        trigger="hover">
                    </lord-icon>
                </button>
            </td>
          </tr>
        </tbody>
      </table>
      <!-- <div class="pagination mt-2">
        <button type="button" class="mr-1" id="pageButton" v-if="currentPage > 1"  @click.prevent="minPage()"> &lt; </button>
        <button class="mr-1" id="pageButton" v-if="currentPage <= 1"  > &lt; </button>
        <p class="mr-1"> {{this.currentPage}} </p>
        <p class="mr-1">/</p>
        <p class="mr-1">{{this.totalPage}} </p> 
        <button type="button" id="pageButton" v-if="this.currentPage < this.totalPage" @click.prevent="addPage()"> > </button>
        <button id="pageButton" v-if="this.currentPage >= this.totalPage" > > </button>
      </div> -->
    </div>

    <!-- modal -->
  <div class="modal" id="mainModal" tabindex="-1">
  <!-- <div class="modal-dialog"> -->
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Jenis Product</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true" >&times; </span>
        </button>
      </div>
      <div class="modal-body">
        <form @submit.prevent="isEdit ? editData() : addData()">

          <div class="inRow">
            <div class="inCol">
              <p id="titleModal">Nama Produk</p>
              <b-input v-model="produckName" required ></b-input>
            </div>
            <div class="inCol">
              <p id="titleModal">type Produk</p>
              <b-input v-model="type" required ></b-input>
            </div>
        </div>
        <div id="titleRow" v-if="isEdit">
          <b-button class="mt-3 text-left" id="addModal" @click.prevent="addRow()">Tambah Baris</b-button>
        </div>
        <div class="inRow"  style="justify-content: space-around;" v-if="isEdit">
          <p>Jenis Material</p>
          <p>Jumlah</p>
        </div>
        <div class="inRow"  v-for="e in this.subItems" :key="e.id" v-if="isEdit">
          <b-select v-model="e.MaterialId" class="mr-5">
            <option v-for="x in materials" :value="x.id" :key="x.id">{{ x.materialName }}</option>
          </b-select>
          <b-input v-model="e.volume" type="number" placeholder="Volume"></b-input>
          <button id="deleteButton"  @click.prevent="deleteRow(e.id)">
            <img src="../assets/trash.png" alt="">
          </button>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
          <button type="submit" class="btn btn-primary"> {{ isEdit ? 'Edit' : 'Tambah' }} </button>
        </div>
      </form>
      </div>
    </div>
  <!-- </div> -->
</div>

<!-- Vehicle -->

  </div>
</template>

<script>
import axios  from '../API/axios'
import Swal from "sweetalert2";
import { v4 as uuidv4 } from 'uuid';
import moment from 'moment'

export default {
  name: "Voucer",
  data() {
    return  {
      dataTable: [],
      id: 0,
      currentPage: 1,
      perPage: 20,
			totalPage : 2,
      isLoading: false,
      isEdit: false,
      
      materials: [],
      subItems: [],
      // filter
      produckName: "",
      type: "",
    }
  },
  created() {
    this.getDataTable()
    this.getMaterial()
    this.$store.dispatch("getBranch")
  },
  computed: {
    branches() {
      return this.$store.state.branches
    }
  },  
  methods: {

    showAdd() {
      this.isEdit = false
      this.produckName = ""
      this.type = ""
      $('#mainModal').modal('show')
    },

    showEdit(e) {
      console.log(e);
      this.produckName = e.produckName
      this.type = e.type
      
      this.subItems = e.StandartProducks
      this.id = e.id
      this.isEdit = true
      if(e.StandartProducks.length < 1) {
        this.addRow()
      }
      $('#mainModal').modal('show')
    },

    addRow() {
      this.subItems.push({
        id: uuidv4(),
        MaterialId: 0,
        volume: 0
      })
    },
    deleteRow(id) {
      this.subItems = this.subItems.filter(e => e.id !== id)
    },  
    async getDataTable() {
      this.isLoading = true
      try {
        
        let {data} = await axios({
          method: "GET",
          url: "/product",
          headers: {
            access_token: localStorage.getItem("access_token")
          },
          // params: {
          //   page: this.currentPage,
          //   limit: this.perPage,
          // }
        })
        console.log(data);
        this.dataTable = data
        this.isLoading = false
      } catch(err) {
        this.isLoading = false
        console.log(err);
      }

    },


    async addData() {

      try {
        
        let proses = await axios({
          method: "POST",
          url: "/product",
          data: {
            produckName : this.produckName,
            type : this.type,
          },
          headers: {
            access_token: localStorage.getItem("access_token")
          },
        })
        this.materialName = "",
        this.getDataTable()
        $('#mainModal').modal('hide')
        Swal.fire('Berhasil', 'Telah diproses', 'success');
      } catch(err) {
        console.log(err);
        this.isLoading = false
      }
    },
    async editData(e) {

      try {

        if(this.subItems.length < 1) {
          throw {
            status: 500,
            msg: 'No'
          }
        }

        this.subItems.map(e => {
          if(e.MaterialId == 0 || e.volume == 0) {
            throw {
            status: 500,
            msg: 'Data is not complete'
          }
          }
        })

        let payload = {
            items: this.subItems,
            ProduckId: this.id,
            produckName : this.produckName,
            type : this.type,
        }
        let data3 = await axios({
          method: "post",
          url: `/product/standar`,
          data: payload,
          headers: {
            access_token: localStorage.getItem("access_token")
          },
        })
        let data2 = await axios({
          method: "put",
          url: `/product/${this.id}`,
          data: payload,
          headers: {
            access_token: localStorage.getItem("access_token")
          },
        })



        $('#mainModal').modal('hide')
        this.produckName=  ""
        this.type=  ""
        this.id=  0
        this.isEdit = false
        this.getDataTable()
        this.$store.dispatch("getBranch")

        Swal.fire('Berhasil', 'Data Berhasil Diubah', 'success');
        
      } catch(err) {
        console.log(err);
        Swal.fire('Maaf', 'Periksa Kembali data anda', 'error');
      }
    }, 

    async deleteData(id) {
      
      try {
        
        let data = await axios.delete(`/product/${id}`, {
          headers: {
            access_token: localStorage.getItem("access_token")
          },
        })
        Swal.fire('Berhasil', 'Data Berhasil Dihapuskan', 'success');
        this.$store.dispatch("getBranch")
        this.getDataTable()
      } catch(err) {
        Swal.fire('Maaf', 'Periksa Kembali data anda', 'error');

      } 
    },
    async confirmDelete(id) {
      
      try {
        let data = await Swal.fire({
            title: 'Yakin?',
            text: 'Apakah Yakin ',
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Hapus!!',
        })
        if (data.isConfirmed) { 
            await this.deleteData(id);
            this.$store.dispatch("getBranch")
            this.getDataTable()
        } else {
                Swal.fire('Ok', 'Proses anda berhasil dibatalkan', 'error');
              }
              
              
            } catch(err) {
              
              Swal.fire('Maaf', 'Proses anda berhasil dibatalkan', 'error');
      }
    },

    async getMaterial() {

      try {
        
        let {data} = await axios({
          method: "GET",
          url: "/material/type",
          headers: {
            access_token: localStorage.getItem("access_token")
          },
        })
        this.materials = data
        this.isLoading = false
      } catch(err) {
        this.isLoading = false
        console.log(err);
      }
    },

    // standar
    async addStandar() {

    },
    addPage() {
      this.currentPage = this.currentPage + 1
          this.$store.dispatch("getBranch")
    },
    minPage() {
      this.currentPage = this.currentPage - 1
          this.$store.dispatch("getBranch")
    },
  }
}
</script>

<style scoped>
  .cardRow {
    /* display: flex; */
    width: 100%;
    /* background-color: aqua; */
  }



 




</style>